import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import './walletFunds.css'

import {
  apiCallGetWalletFunds,
  apiCallGetArtrunerWallet
} from '../../../../Core/Apicall'

import {
  setLoadingFalse,
  setLoadingTrue
} from '../../../../Config/Actions/loadingActions'

import EmptyData from '../../../../Components/EmptyData/EmptyData'
import CustomPagination from '../../../../Components/CustomPagination/CustomPagination'

const WalletFunds = ({ userId, title, apiFunction }) => {

  const dispatch = useDispatch()
  const isLoading = useSelector(state => state.isLoading)

  const [walletData, setWalletData] = useState([])
  const [pagination, setPagination] = useState({})
  const [initialPage, setInitialPage] = useState(1)
  const [walletBalance, setWalletBalance] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);

  // =========================
  // Get Wallet Funds
  // =========================

  const getWalletFunds = async (selectedPage = 1) => {

    dispatch(setLoadingTrue())

    try {
      let param;

      if (title === "ArtRunner Wallet") {
        param = {
          artRunnerId: userId,
          offset: selectedPage,
          limit: 10
        }
      } else {
        param = {
          userId: userId,
          offset: selectedPage,
          limit: 10
        }
      }

      const res = await apiFunction(param)

      setWalletBalance(res?.data?.currentBalance || 0);
      setTotalBalance(res?.data?.totalEarning || 0);

      // New response structure: data contains walletHistory array with event groups
      setWalletData(
        res?.data?.walletHistory || []
      )

      setPagination({
        totalRecords:
          res?.data?.totalRecords || 0,

        pages: Math.ceil(
          (res?.data?.totalRecords || 0)
          / (res?.data?.limit || 10)
        )
      })

      setInitialPage(selectedPage)

    } catch (error) {

      console.error(
        'Wallet Funds Error:',
        error
      )

    } finally {

      dispatch(setLoadingFalse())

    }
  }

  useEffect(() => {

    if (userId) {
      getWalletFunds(1)
    }

  }, [userId])

  return (
    <div>

      <div className='achievements'>
        <div className='upcoming_list'>

          <div className='margin-top-20 achievement-container'>

            {/* Header */}
            <div className='achievement-header'>

              {/* Left Side */}
              <div className='achievement-title'>
                <div className='astrologerText'>
                  {title}
                </div>
              </div>

              {/* Right Side */}
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  alignItems: "center"
                }}
              >

                {/* User Wallet */}
                {title === "User Wallet" && (
                  <div
                    style={{
                      background: "rgba(0,255,157,0.1)",
                      border: "1px solid rgba(0,255,157,0.3)",
                      borderRadius: "12px",
                      padding: "12px 20px",
                      minWidth: "220px"
                    }}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#9ca3af",
                        marginBottom: "5px"
                      }}
                    >
                      Current Wallet Balance
                    </div>

                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: "700",
                        color: "#00ff9d"
                      }}
                    >
                      ${walletBalance || 0}
                    </div>
                  </div>
                )}

                {/* ArtRunner Wallet */}
                {title === "ArtRunner Wallet" && (
                  <>
                    {/* Payable Balance */}
                    <div
                      style={{
                        background: "rgba(0,255,157,0.1)",
                        border: "1px solid rgba(0,255,157,0.3)",
                        borderRadius: "12px",
                        padding: "12px 20px",
                        minWidth: "220px"
                      }}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#9ca3af",
                          marginBottom: "5px"
                        }}
                      >
                        Payable Balance
                      </div>

                      <div
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#00ff9d"
                        }}
                      >
                        ${walletBalance || 0}
                      </div>
                    </div>

                    {/* Total Earnings */}
                    <div
                      style={{
                        background: "rgba(59,130,246,0.1)",
                        border: "1px solid rgba(59,130,246,0.3)",
                        borderRadius: "12px",
                        padding: "12px 20px",
                        minWidth: "220px"
                      }}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#9ca3af",
                          marginBottom: "5px"
                        }}
                      >
                        Total Earnings
                      </div>

                      <div
                        style={{
                          fontSize: "22px",
                          fontWeight: "700",
                          color: "#3b82f6"
                        }}
                      >
                        ${totalBalance || 0}
                      </div>
                    </div>
                  </>
                )}

              </div>

            </div>

            {/* Table */}
            <div className='achievement-content'>

              {/* Table Header */}

              <div className='achievement-content-header'>

                <div className='lastWeekEndDivGreyColor table-col-user'>
                  User
                </div>

                <div className='lastWeekEndDivGreyColor table-col-transaction-for'>
                  Transaction For
                </div>

                <div className='lastWeekEndDivGreyColor table-col-type'>
                  Type
                </div>

                <div className='lastWeekEndDivGreyColor table-col-amount'>
                  Amount
                </div>

                <div className='lastWeekEndDivGreyColor table-col-final-balance'>
                  Final
                </div>

                <div className='lastWeekEndDivGreyColor table-col-date'>
                  Date
                </div>

              </div>

              {/* Wallet List */}

              <div className='scrollable-container h-max-350'>

                {
                  !isLoading && walletData.length === 0 ? (

                    <EmptyData />

                  ) : (

                    // Map through event groups
                    walletData.map((eventGroup, groupIndex) => (

                      <div key={groupIndex} className='event-group-container'>

                        {/* Event Group Header - Centered with small font */}
                        <div className="event-group-header"
                        // style={{
                        //   display: 'flex',
                        //   justifyContent: 'center',
                        //   alignItems: 'center',
                        //   gap: '20px',
                        //   padding: '10px 0',
                        //   backgroundColor: 'rgba(255,255,255,0.05)',
                        //   borderRadius: '8px',
                        //   marginBottom: '10px',
                        //   borderBottom: '1px solid rgba(255,255,255,0.1)'
                        // }}
                        >
                          <span className="event-group-name">
                            {eventGroup?.eventName || '-'}
                          </span>
                          <span className="event-group-date">
                            {eventGroup?.eventDate ? moment(eventGroup.eventDate).format('DD/MM/YYYY') : '-'}
                          </span>
                          <span className="event-group-date">
                            {eventGroup?.eventTime ? moment(eventGroup.eventTime, 'HH:mm:ss').format('hh:mm A') : '-'}
                          </span>
                        </div>

                        {/* Transactions for this event group */}
                        {eventGroup?.transactions?.map((item, index) => (

                          <div
                            key={index}
                            className='achievement-content-header'
                            style={{
                              borderBottom: index === eventGroup.transactions.length - 1 ? 'none' : '1px solid rgba(255,255,255,0.05)'
                            }}
                          >

                            {/* User */}

                            <div
                              className='table-col-user'
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px'
                              }}
                            >

                              <img
                                src={item?.artRunnerData?.profileImage || item?.userData?.profileImage}
                                alt='profile'
                                style={{
                                  width: '45px',
                                  height: '45px',
                                  borderRadius: '50%',
                                  objectFit: 'cover'
                                }}
                              />

                              <div
                                style={{
                                  overflow: "hidden"
                                }}
                              >

                                <div
                                  style={{
                                    fontWeight: 600
                                  }}
                                >
                                  {item?.artRunnerData?.name || item?.userData?.name}
                                </div>

                                <div
                                  style={{
                                    fontSize: '12px',
                                    opacity: 0.7,
                                    marginTop: '3px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }}
                                >
                                  {item?.artRunnerData?.email || item?.userData?.email}
                                </div>

                              </div>

                            </div>

                            {/* Transaction For */}

                            <div className='table-col-transaction-for'>

                              <span
                                className={`wallet-transaction-badge 
                                ${item?.transactionFor === "WalletTopup"
                                    ? "wallet-topup"

                                    : item?.transactionFor === "TicketPurchase"
                                      ? "ticket-purchase"

                                      : item?.transactionFor === "Refund"
                                        ? "refund"

                                        : item?.transactionFor === "Withdraw" ||
                                          item?.transactionFor === "Withdrawal"
                                          ? "withdraw"

                                          : item?.transactionFor === "TicketRefund"
                                            ? "ticket-refund"

                                            : item?.transactionFor === "TicketCancelRefund" ||
                                              item?.transactionFor === "EventCancelRefund" ||
                                              item?.transactionFor === "EventRefund" ||
                                              item?.transactionFor === "WalletRefund"
                                              ? "cancel-refund"

                                              : item?.transactionFor === "Cashback"
                                                ? "cashback"

                                                : item?.transactionFor === "EventBooking"
                                                  ? "event-booking"

                                                  : item?.transactionFor === "PlatformFee"
                                                    ? "platform-fee"

                                                    : item?.transactionFor === "Tax"
                                                      ? "tax-fee"

                                                      : item?.transactionFor === "StripeFee"
                                                        ? "stripe-fee"

                                                        : ""
                                  }
    `}
                              >

                                {
                                  {
                                    WalletTopup: "Wallet Topup",
                                    WalletRefund: "Wallet Refund",

                                    TicketPurchase: "Ticket Purchase",

                                    Refund: "Refund",

                                    Withdraw: "Withdraw",

                                    TicketRefund: "Ticket Refund",

                                    TicketCancelRefund:
                                      "Ticket Cancel Refund",

                                    Cashback: "Cashback",

                                    Withdrawal: "Withdrawal",

                                    EventCancelRefund:
                                      "Event Cancel Refund",

                                    EventBooking:
                                      "Event Booking",

                                    EventRefund:
                                      "Event Refund",

                                    PlatformFee:
                                      "Platform Fee",

                                    Tax:
                                      "Tax",

                                    StripeFee:
                                      "Stripe Fee",



                                  }[item?.transactionFor] || "-"
                                }

                              </span>

                            </div>

                            {/* Type */}

                            <div className='table-col-type'>

                              <div
                                style={{
                                  background:
                                    item?.transactionType === 'Credit'
                                      ? 'rgba(0,255,157,0.12)'
                                      : 'rgba(255,77,77,0.12)',

                                  color:
                                    item?.transactionType === 'Credit'
                                      ? '#00ff9d'
                                      : '#ff4d4d',

                                  padding: '8px 15px',
                                  borderRadius: '50px',
                                  width: 'fit-content',
                                  fontSize: '13px',
                                  fontWeight: '600'
                                }}
                              >
                                {item?.transactionType}
                              </div>

                            </div>

                            {/* Amount */}

                            <div
                              className='table-col-amount'
                              style={{
                                fontWeight: '700'
                              }}
                            >
                              ${item?.finalAmount || item?.amount}
                            </div>

                            {/* Final Balance */}

                            <div
                              className='table-col-final-balance'
                              style={{
                                fontWeight: '700'
                              }}
                            >
                              ${item?.availableBalance}
                            </div>

                            {/* Date */}

                            <div className='table-col-date'>

                              {moment(item?.createdAt).format(
                                'DD/MM/YYYY hh:mm A'
                              )}

                            </div>

                          </div>

                        ))}
                      </div>
                    ))
                  )
                }

              </div>

            </div>

          </div>
          {/* Pagination */}

          {
            walletData?.length > 0 &&
            (<div style=
              {{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '20px'
              }}
            >
              <CustomPagination
                pageCount={pagination?.pages || 1}
                forcePage={initialPage - 1}
                onPageChange={({ selected }) => {
                  const page = selected + 1;
                  setInitialPage(page);
                  getWalletFunds(page);
                }}
              />
            </div>
            )
          }

        </div>
      </div>

    </div>
  )
}

export default WalletFunds